import { useCallback } from "react";

import { unlocalizePathname } from "./localizedLocation";
import { intlMessages as routesContextIntlMessages } from "../Routes/routesConfig";
import { useFormatMessage } from "../Intl/Context";

const isLibraryFileUrl = (url, libraryPath) => {
  if (!url || !libraryPath) return false;

  // Library file URLs are already localized by the backend (e.g. "/ca/...").
  // We normalize the path by removing the locale prefix before matching the
  // library route, otherwise "/ca/..." would fail the "/bibliotheque/..." check.
  const rawPath = new URL(url, window.location.origin).pathname;
  const path = unlocalizePathname(rawPath);

  return path.startsWith(`/${libraryPath}/`);
};

export const useIsLibraryFileUrl = () => {
  const t = useFormatMessage();
  const libraryPath = t(routesContextIntlMessages.library);

  return useCallback(url => isLibraryFileUrl(url, libraryPath), [libraryPath]);
};
